module.exports = __webpack_public_path__ + "static/media/safetypins-illustration.caf4d3c3.png";